import { useSelector } from "react-redux";

import { IS_AWS_ENV } from "constants/app.constants";
import { RootState } from "store/rootReducer";

import type { IColorPalette } from "models/colorPalette";

/**
 * On AWS every rig/frac surface (map layers, layer legend, charts) spreads the
 * well focus's active palette over its values instead of Plasma, so rig/frac
 * reads in the same colours as the wells whatever field it is coloured by
 * (EVA-338). Always the well palette, never the facility one: rig/frac colour
 * sync follows the well focus only. Undefined on Azure, which keeps Plasma.
 */
export function useRigFracBasePalette(): Maybe<IColorPalette> {
  const activePalette = useSelector(
    (state: RootState) => state.userSetting?.activeColorPalette
  );
  return IS_AWS_ENV ? activePalette : undefined;
}
